import { useSettingsContext } from "@/pages/settings/SettingsProvider";
import { useEffect, useRef } from "react";

export interface NodeData {
  id: string;
  name: string;
  children?: NodeData[];
}

// Hook to get complaint codes from settings
export const useComplaintCodes = (): NodeData[] => {
  const hasWarnedRef = useRef(false);
  const { settings, isLoading } = useSettingsContext();
  const complaintCodes = (settings as any)?.complaintCodes;
  
  // Warn user if settings are loaded but no complaint codes found
  useEffect(() => {
    if (!isLoading) {
      if (!complaintCodes || !Array.isArray(complaintCodes) || complaintCodes.length === 0) {
        if (!hasWarnedRef.current) {
          console.warn(
            "No complaint codes found in settings. Please configure complaint codes in Settings > Complaint Codes."
          );
          hasWarnedRef.current = true;
        }
      } else {
        // Reset warning flag if data is available
        hasWarnedRef.current = false;
      }
    }
  }, [isLoading, complaintCodes]);
  
  // If settings has complaintCodes and it's not empty, use it
  if (complaintCodes && Array.isArray(complaintCodes) && complaintCodes.length > 0) {
    return complaintCodes as NodeData[];
  }
  
  // Return empty array if no data
  return [];
};